import { z } from "zod/v4";

import { AudienceDtoSchema } from "../../../../dtos/audiences";

export const PluginAudienceSchema_2024_05_05 = AudienceDtoSchema.omit({
  id: true,
}).extend({
  experienceId: z.uuid(),
});
export type PluginAudienceType_2024_05_05 = z.infer<
  typeof PluginAudienceSchema_2024_05_05
>;
